import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NotificationTypes } from '@core/domain/model/notifications/notification.model';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { NotificationIcon } from './notification-icon.typing';

@Component({
  selector: 'ac-notification-icon',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './notification-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationIconComponent {
  @Input({ required: true }) type!: NotificationTypes;
  @Input({ required: true }) isUrgent!: boolean;

  get icon(): NotificationIcon {
    const iconsMap: Record<NotificationTypes, string> = {
      [NotificationTypes.PROCEDURE]: 'alert',
      [NotificationTypes.MARKET]: 'alert',
      [NotificationTypes.ACCIONA_ENERGY]: 'bocina_altavoz',
      [NotificationTypes.CONTRACT]: 'mail',
      [NotificationTypes.DRAFT]: 'alert',
      [NotificationTypes.INVOICE]: this.getIconInvoice(),
      [NotificationTypes.USUARIOS]: 'document',
      [NotificationTypes.ERROR_CRM_PROCEDURE]: 'alert',
    };

    return { name: iconsMap[this.type], color: this.getIconColor() };
  }

  private getIconColor() {
    return this.isUrgent || this.type === NotificationTypes.MARKET || this.type === NotificationTypes.ERROR_CRM_PROCEDURE
      ? 'warning'
      : 'default';
  }

  private getIconInvoice() {
    return this.isUrgent && this.type === NotificationTypes.INVOICE ? 'alert' : 'mail';
  }
}
